import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ApplicantService } from 'src/app/services/applicant.service';
import { CoApplicantService } from 'src/app/services/co-applicant.service';
import { LoaderService } from 'src/app/services/loader.service';
import { QuestionService } from 'src/app/services/question.service';
import { TosterService } from 'src/app/services/toster.service';
import { noWhitespaceValidator } from 'src/shared/whitespace.validator';
@Component({
  selector: 'app-section',
  templateUrl: './section.component.html',
  styleUrls: ['./section.component.css'],
})
export class SectionComponent implements OnInit {
  section_no: any = '';
  udata: any;
  questions: any;
  subsection: any;
  criteria: any;
  criterias: any;
  public model: any = {};
  modall: any = [];
  isView: boolean = false;
  Sectionform!: FormGroup;
  flag: any;
  finalStatus: boolean = true;
  queryCriteria: string = '';
  headers: any = {
    'Criteria 1': {
      A: 'General Regulatory Requirements',
      B: 'Food Safety Practices',
    },
    'Criteria 11': {
      A: 'Statutory, Regulatory and Social Compliance',
      B: 'Laboratory Management',
      C: 'Leadership and Best Practices in Laboratory Initiatives',
    },
    'Criteria 2A for SMB': {
      '01': 'General Regulatory Requirement',
      '02': 'Location of Food counters and Kitchen',
      '03': 'Working Surface',
      '04': 'Facilities',
      '05': 'Equipment & Utensils',
      '06': 'Incoming Material Control',
      '07': 'Control of Operation',
      '08': 'Risk Based Approach',
      '09': 'Allergen Management',
      '10': 'Personal Hygiene',
      '11': 'Washing & Cleaning',
      '12': 'Pest Management',
      '13': 'Measures to prevent cross contaminations',
      '14': 'Display of Food',
      '15': 'Emergency Preparedness',
      '16': 'Management & Supervision',
      '17': 'Eating facilities for Customers',
      '18': 'People, Competence & Awareness',
      '19': 'Product Information and Customer Awareness',
      '20': 'Cont Imp, System, Tools and Techniques',
      '21': 'Recognition of People',
      '22': 'Canteen Management in Food Safety and Sustainability',
      '23': 'Food Takeaways/ Food Delivery',
      '24': 'Food Defence',
      '25': 'Food Loss - Food Waste',
      '26': 'Internal Checks/ Internal Audits'
    },
    'Criteria 2A Large': {
      '01': 'General Regulatory Requirement',
      '02': 'Location of Food counters and Kitchen',
      '03': 'Working Surface',
      '04': 'Facilities',
      '05': 'Equipment & Utensils',
      '06': 'Incoming Material Control',
      '07': 'Control of Operation',
      '08': 'Risk Based Approach',
      '09': 'Allergen Management',
      '10': 'Personal Hygiene',
      '11': 'Washing & Cleaning',
      '12': 'Pest Management',
      '13': 'Measures to prevent cross contaminations',
      '14': 'Display of Food',
      '15': 'Emergency Preparedness',
      '16': 'Management & Supervision',
      '17': 'Eating facilities for Customers',
      '18': 'People, Competence & Awareness',
      '19': 'Product Information and Customer Awareness',
      '20': 'Cont Imp, System, Tools and Techniques',
      '21': 'Recognition of People',
      '22': 'Canteen Management in Food Safety and Sustainability',
      '23': 'Food Takeaways/ Food Delivery',
      '24': 'Food Defence',
      '25': 'Food Loss - Food Waste',
      '26': 'Internal Checks/ Internal Audits'
    },
    'Criteria 2B for SMB': {
      '01': 'General Regulatory Requirement',
      '02': 'Location of Kitchen',
      '03': 'Working Surface',
      '04': 'Facilities',
      '05': 'Management of Equipment & Utensils',
      '06': 'Incoming Material Control',
      '07': 'Control of Operation',
      '08': 'Risk Based Approach',
      '09': 'Allergen Management',
      '10': 'Personal Hygiene',
      '11': 'Washing & Cleaning',
      '12': 'Pest Management',
      '13': 'Measures to prevent cross contaminations',
      '14': 'Delivery of Food',
      '15': 'Emergency Preparedness',
      '16': 'Management & Supervision',
      '17': 'Delivery Containers , Personnel & Transport',
      '18': 'People, Competence, Culture & Awareness',
      '19': 'Product Information and Customer Awareness',
      '20': 'Continual Improvement System, Tools and Techniques',
      '21': 'Recognition of People'
    },
    'Criteria 2B Large': {
      '01': 'General Regulatory Requirement',
      '02': 'Location of Kitchen',
      '03': 'Working Surface',
      '04': 'Facilities',
      '05': 'Management of Equipment & Utensils',
      '06': 'Incoming Material Control',
      '07': 'Control of Operation',
      '08': 'Risk Based Approach',
      '09': 'Allergen Management',
      '10': 'Personal Hygiene',
      '11': 'Washing & Cleaning',
      '12': 'Pest Management',
      '13': 'Measures to prevent cross contaminations',
      '14': 'Delivery of Food',
      '15': 'Emergency Preparedness',
      '16': 'Management & Supervision',
      '17': 'Delivery Containers , Personnel & Transport',
      '18': 'People, Competence, Culture & Awareness',
      '19': 'Product Information and Customer Awareness',
      '20': 'Continual Improvement System, Tools and Techniques',
      '21': 'Recognition of People'
    },
    'Criteria 2 for SMB': {
      A: 'Self-Declaration',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 3 Large': {
      A: 'Self-Declaration',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 3A1 Large': {
      A: 'Self-Declaration',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 3A1 for SMB': {
      A: 'Self-Declaration',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 3A2 Large': {
      A: 'Self-Declaration',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 3A2 for SMB': {
      A: 'Self-Declaration',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 3 for SMB': {
      A: 'Self-Declaration',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 4': {
      A: 'Social & Regulatory Requirement',
      B1: 'Pre-Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Sector Specific Good Manufacturing Practices',
      D: 'Change Management Initiatives'
    },
    'Criteria 5': [],
    'Criteria 7': {
      A: 'Self-Declaration',
      B4: 'Management of Partnerships',
    },
    'Criteria 9': {
      A: 'Statutory & Regulatory Requirements & Social Compliance',
      B1: 'Pre Requisite Programs',
      B2: 'Hazard Analysis and Critical Control Point',
      B3: 'Food Safety Management System Structure',
      C: 'Good Manufacturing Practices (GMP)',
      D: 'Change Management Initiatives'
    },
  }

  constructor(
    private toast: TosterService,
    private _Activatedroute: ActivatedRoute,
    private quest: QuestionService,
    private applicat: ApplicantService,
    private fb: FormBuilder,
    private loaderService: LoaderService,
    private coapp: CoApplicantService
  ) { }
  ngOnInit(): void {
    this._Activatedroute.paramMap.subscribe((params: any) => {
      this.section_no = params.get('section_no');
      this.flag = params.get('flag');
      if (this.section_no === '' || this.section_no === null) {
        window.location.href = '/dashboard';
        return;
      }
      this.loadData();
    });
    this._Activatedroute.queryParamMap.subscribe((query: any) => {
      this.queryCriteria = query.params.criteria
    })
  }
  private loadData(): void {
    this.modall = [];
    this.udata = localStorage.getItem('userdata') || '{}';
    this.udata = JSON.parse(this.udata);
    let email = this.udata.email;
    this.loaderService.showLoading();
    this.applicat
      .GetAdminApplicantSinglebyemail(email)
      .subscribe((data: any) => {
        if (data.applicanData.criteria != '') {
          this.criteria = data.applicanData.criteria;
          this.criterias = [data.applicanData.criteria];
          this.coapp.listCoApplicant(data.applicanData._id).subscribe((resp: any) => {
            if (resp.result.length) {
              // this.navToCoDirectly = true
              // this.coid = resp.result[0]._id
              let criterias = resp.result.map((coapps: any) => {
                return coapps.co_criteria
              })
              this.criterias = [data.applicanData.criteria].concat(criterias)
              this.criterias = Array.from(new Set(this.criterias))
            } else {
              this.criterias = [data.applicanData.criteria]
            }
            this.quest
              .viewQuestionByCriterias({
                criterias: this.criterias,
                section_no: this.section_no,
              })
              .subscribe((item: any) => {
                let a: any[] = item.sec.filter((item: any) => {
                  return item.question_title !== 'Findings / Remarks'
                });
                let b: any[] = item.sec.filter((item: any) => {
                  return item.question_title == 'Findings / Remarks'
                });
                this.questions = [...a, ...b];
                this.subsection = this.removeDuplicateObjectFromArray(
                  item.sec,
                  'sub_section_no'
                );
                this.model = []
                item.sec.map((element: any) => {
                  this.model[element._id] = '';
                });
                this.quest.viewFinallyWithCriterias({
                  email: this.udata.email,
                  criterias: this.criterias,
                  type: this.udata.role,
                })
                  .subscribe(async (elem: any) => {
                    this.finalStatus = (elem.ass.length == 0 ? true : false)
                  })
                this.quest
                  .viewAssessment({
                    section_no: this.section_no,
                    email: this.udata.email,
                    criteria: this.queryCriteria,
                    type: this.udata.role,
                  })
                  .subscribe(async (ele: any) => {
                    if (ele.ass.length) {
                      let lastIndex = ele.ass.length - 1;
                      this.modall = await ele.ass[lastIndex].assessment[0];
                      let finalModal: any = {};
                      this.questions.forEach((element: any) => {
                        if (this.modall && this.modall[element._id]) {
                          finalModal[element._id] = this.modall[element._id];
                        } else {
                          finalModal[element._id] = '';
                        }
                      });
                      this.Sectionform = this.fb.group(finalModal);
                    } else {
                      this.formInit(this.model);
                    }
                    if (this.flag != 0) {
                      this.onSubmit();
                    }
                    this.loaderService.hideLoading();
                  });
              });
          })
        }        
      });
  }
  formInit(model: any) {
    this.Sectionform = this.fb.group(model);
  }
  public get f() {
    return this.Sectionform.controls;
  }
  removeDuplicateObjectFromArray(array: any, key: any) {
    return array.filter(
      (obj: any, index: any, self: any) =>
        index === self.findIndex((el: any) => el[key] === obj[key])
    );
  }
  onChangeControl(id: any, e: any, chk: any) {
    //undefined
    this.Sectionform.controls[id]?.setValue(chk == null ? e.target.value : e);
    // if (this.flag != 0) {
    // }
    // else{
    //   this.Sectionform.value[id] = chk == null ? e.target.value : e;
    // }
  }
  checkOFIs(item_inner: any) {
    if (this.udata.role == 'applicant' || this.udata.role == 'Applicant') {
      const { question_title, question_description } = item_inner;
      return !(question_title && question_title.includes('OFIs')) && !(question_description && question_description.includes('OFIs'));
    }
    else
      return true;
  }
  onSubmit() {
    if (this.flag == 0) {
      for (var key in this.modall) {
        this.Sectionform.controls[key]?.clearValidators();
        this.Sectionform.controls[key]?.updateValueAndValidity();
      }
      this.quest
        .saveAssessment({
          assessment: this.Sectionform.value,
          section_no: this.section_no,
          email: this.udata.email,
          criteria: this.queryCriteria,
          type: this.udata.role,
          applicant_id: '',
          status: false
        })
        .subscribe((item: any) => {
          this.toast.showInfo('Section Saved.');
          this.quest
            .viewQuestionSec({ criteria: this.queryCriteria })
            .subscribe((item: any) => {
              let ind = item.sec.indexOf(this.section_no);
              if (item.sec.length == ind + 1) {
                window.location.href = '/preview';
              } else {
                window.location.href = '/section/' + item.sec[ind + 1] + '/0';
              }
            });
        });
    } else {
      for (var key in this.modall) {
        this.Sectionform?.controls[key]?.setValidators([Validators.required, noWhitespaceValidator]);
        this.Sectionform?.controls[key]?.updateValueAndValidity();
      }
      if (this.Sectionform.invalid) {
      }
      else {
        this.quest
          .saveAssessment({
            assessment: this.Sectionform.value,
            section_no: this.section_no,
            email: this.udata.email,
            criteria: this.queryCriteria,
            type: this.udata.role,
            applicant_id: '',
            status: true
          })
          .subscribe((item: any) => {
            this.toast.showInfo('Review done.');
            this.quest
              .viewQuestionSec({ criteria: this.criteria })
              .subscribe((item: any) => {
                let ind = item.sec.indexOf(this.section_no);
                if (item.sec.length == ind + 1) {
                  window.location.href = '/review';
                } else {
                  window.location.href = '/section/' + item.sec[ind + 1] + '/0';
                }
              });
          });
      }
    }
  }

  saveCsv() {
    const csvData: string[][] = [];

    // Add header row
    csvData.push(['Sub Section', 'Qs #', 'Checkpoint Title', 'Checkpoint', 'Selection / Description']);

    // Traverse each subsection
    this.subsection.forEach((sub: any) => {
      // Traverse all questions and find the ones matching this subsection
      this.questions.forEach((q: any) => {
        if (q.sub_section_no === sub.sub_section_no) {
          const qNo = q.question_no ? `Q - ${q.question_no}` : '';
          const title = q.question_title || '';
          const desc = q.question_description || '';
          const answer = this.modall[q._id] ?? '';

          csvData.push([
            `${sub.sub_section_no} : ${sub.sub_section_title}`,
            qNo,
            title,
            desc,
            answer
          ]);
        }
      });
    });

    // Convert CSV rows into strings
    const csvRows = csvData.map(row =>
      row.map(value => `"${String(value).replace(/"/g, '""')}"`).join(',')
    );

    // Create CSV string
    const csvString = csvRows.join('\r\n');
    const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);

  // Trigger download
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `section-${this.section_no}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}
}
